import { ConnectedPosition } from '@angular/cdk/overlay';

export const COLOR_SELECT_ESCAPE_KEY = 'Escape';

export const COLOR_SELECT_PALETTE: ReadonlyArray<string> = [
  '#000000',
  '#525252',
  '#8c8c8c',
  '#d9d9d9',
  '#f70f1b',
  '#e6194b',
  '#ee8031',
  '#ffb000',
  '#ffe119',
  '#bfef45',
  '#3cb44b',
  '#316e2f',
  '#42d4f4',
  '#53b9ec',
  '#1063ed',
  '#4363d8',
  '#911eb4',
  '#f032e6',
  '#9a6324',
  '#704014',
];

export const COLOR_SELECT_POSITIONS: ConnectedPosition[] = [
  {
    originX: 'center',
    originY: 'bottom',
    overlayX: 'center',
    overlayY: 'top',
    offsetY: 6,
  },
  {
    originX: 'center',
    originY: 'top',
    overlayX: 'center',
    overlayY: 'bottom',
    offsetY: -6,
  },
];

export const COLOR_SELECT_CUSTOM_LABEL = 'Custom color';
export const COLOR_SELECT_RESET_LABEL = 'Reset to Default';

export const COLOR_SELECT_HUE_MAX = 360;

export const COLOR_SELECT_HEX_PATTERN = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

export const COLOR_SELECT_HEX_LABEL = 'Hex color';

// Used only when neither the value nor the default is a valid hex color.
export const COLOR_SELECT_FALLBACK_COLOR = '#000000';

// Every 60 degrees is a primary or secondary hue, enough for a smooth track.
export const COLOR_SELECT_HUE_STOPS = 6;

export const COLOR_SELECT_CHANNEL_MAX = 255;

export const COLOR_SELECT_RGB_LABELS: ReadonlyArray<string> = ['R', 'G', 'B'];

export const COLOR_SELECT_HEX_FIELD_LABEL = 'HEX';

export const COLOR_SELECT_EYEDROPPER_LABEL = 'Pick a color from the screen';

export const COLOR_SELECT_FORMAT_TOGGLE_LABEL = 'Switch between RGB and HEX';
